(function(angular){
	'use strict';

	angular
		.module('featuresModule')
		.controller('FeaturesController', [
			'featuresFactory',
			FeaturesControllerFunction
		]);

	function FeaturesControllerFunction(
		featuresFactory
	){
		var features = this;

		features.$onInit = function() {
			features.statuses = ['available', 'unavailable', 'complete'];
			featuresFactory.getAccountFeatures()
				.then(function(accountFeatures) {
					features.loaded = true;
					angular.extend(features, accountFeatures);
				});
		};
	}
})(window.angular);